import { Controller } from '@hotwired/stimulus'

// Points a <select> that lives OUTSIDE the turbo stream at a value the stream carries.
// The add-company modal is what needs it: its response has to leave the vacancy form's
// company select showing the company just entered, and that select is not part of the
// modal being re-rendered.
//
// It adds the option when the select has no such value (a company that was just created)
// and reuses the one already there when it does (CompanyMatcher linked the entry to an
// existing company — appending unconditionally is what used to list it twice).
export default class extends Controller {
  static values = {
    for: String,
    selected: String,
    label: String
  }

  connect () {
    const select = document.getElementById(this.forValue)

    if (select === null || this.selectedValue === '') return

    const known = [...select.options].some((option) => option.value === this.selectedValue)

    if (!known) select.add(new Option(this.labelValue, this.selectedValue))

    select.value = this.selectedValue

    // Anything watching the form has to see this as a real edit — `submit-gate` re-checks
    // validity on `input`/`change` and would otherwise keep the send button dead on a form
    // whose last required field was just filled in.
    select.dispatchEvent(new Event('input', { bubbles: true }))
    select.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
